import React, { useEffect } from 'react';
import './attachment-modal.component.scss';
import ImageIcon from '@mui/icons-material/Image';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import { LoadingService } from '../../services/loading.service';
import { ListMediaService, UploadFileService } from '../../services/api-pages.service';
import { SnackService } from '../../services/snack.service';
import AttachmentModel from '../../models/attachment.model';
import { getAuthUser, getSiteID } from '../../services/auth';
import UsuarioModel from '../../models/usuario.model';
import { CloudUpload } from '@mui/icons-material';
import { ItensGaleria } from '../../models/galeria.model';
import FileWpModel from '../../models/file-wp.model';

type AttachmentModalProps = {
  setVal: (attachFile: FileWpModel) => void;
  file?: FileWpModel;
  legenda?: string;
}

function AttachmentModalComponent(props: AttachmentModalProps) {

  const [listAttach, setListAttach] = React.useState<Array<ItensGaleria>>([]);
  const [abreModal, setAbreModal] = React.useState<boolean>(false);
  const [imgSelecionada, setImgSelecionada] = React.useState<string | undefined>(props.file?.src);
  const [siteID, setSiteID] = React.useState<string>(getSiteID());

  const [usuario, setUsuario] = React.useState<UsuarioModel>(getAuthUser());
  const [fileSelected, setFileSelected] = React.useState<File | undefined>();
  const [refFile, setRefFile] = React.useState<any>();

  useEffect(() => {
    setTimeout(() => {
      uploadFile();
    }, 200);
  }, [fileSelected]);

  const ListMedia = () => {
    LoadingService.sendLoadingAtivo(true);
    ListMediaService({ ID: usuario.site_id }).then(res => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        setListAttach(res.data);
        setAbreModal(true);
      }
    }).catch(err => {
      SnackService.sendMSG('Erro com a conexão.');
      LoadingService.sendLoadingAtivo(false);
      console.log(err);
    });
  }

  const handleImageChange = function (e: React.ChangeEvent<HTMLInputElement>) {
    const fileList = e.target.files;

    if (!fileList) return;

    setFileSelected(fileList[0]);

    uploadFile();
  };

  const uploadFile = () => {
    if (fileSelected) {
      const formData = new FormData();
      formData.append("file", fileSelected, fileSelected.name + '-777-' + usuario.ID + '-777-' + usuario.site_id);
      formData.append('action', 'md_support_save');

      UploadFilleModal(formData);
    }
  };

  const UploadFilleModal = (formData: any) => {

    LoadingService.sendLoadingAtivo(true);

    UploadFileService(formData).then((res) => {
      LoadingService.sendLoadingAtivo(false);
      if (res.data.error) {
        SnackService.sendMSG(res.data.error);
      } else {
        if (res.data.error) {
          SnackService.sendMSG(res.data.error);
        } else {
          // setFoto(res.data.foto);
          // setFileSelected(undefined);
          // SnackService.sendMSG('Imagem alterada!');

          // let tempUser = usuario;
          // tempUser.foto = res.data.foto;
          // localStorage.setItem("user", JSON.stringify(tempUser));
          // setUsuario(tempUser);
          // UsuarioEfetuouLoginService.sendMSG(tempUser);

          console.log(res.data.foto);
          ListMedia();
        }

        setFileSelected(undefined);
      }
    }).catch(err => {
      LoadingService.sendLoadingAtivo(false);
      SnackService.sendMSG('Erro com a conexão.');
      console.log(err);
    });
  }

  return (
    <section className='attachment-modal'>
      <div className="box-img-selecionada">
        {
          imgSelecionada &&
          <img className='selecionada' src={imgSelecionada} alt="Selecionada" />
        }
        <Button className='bt' onClick={ListMedia}>
          <span className='flex'><ImageIcon /> {props.legenda}</span>
        </Button>
      </div>
      <div className={"modal-media ativo-" + abreModal}>
        <div className="box">
          <div className="scrolly">
            {
              listAttach ? listAttach.map((item, indexMedia) => (
                <img onClick={() => {
                  setImgSelecionada(item.src);
                  setAbreModal(false);
                  props.setVal({ id: item.id, src: item.src });
                }} src={item.src} alt={item.id} key={indexMedia} />
              )) : <span>Nenhum item encontrado.</span>
            }
          </div>

          <Button className='fechar' onClick={() => setAbreModal(false)}><CloseIcon /></Button>
          <input
            accept="image/*"
            id="photo"
            name="photo"
            type="file"
            style={{ display: 'none' }}
            multiple={false}
            onChange={handleImageChange}
            ref={input => setRefFile(input)}
          />
          <Button className='bt-upload' onClick={() => refFile.click()}>
            <CloudUpload /> Enviar arquivo
          </Button>
        </div>
      </div>
    </section>
  );
}

export default AttachmentModalComponent;
